import Layout from '../../../layout/Layout'
import HeaderPageSection from 'core/presentation/components/molecules/HeaderPageSection/HeaderPageSection'
import PatternList from 'components/organisms/PatternList/PatternList'
import { useNavigate } from 'react-router-dom'
import AppButton from 'components/atoms/AppButton/AppButton'
import { usePermissions } from 'hooks/usePermissions'
import { RolePermissions } from 'utils/constants'

export default function TemplatePage() {
    const navigate = useNavigate()
    const { can } = usePermissions()
    return (
        <Layout>
            <HeaderPageSection title="Plantillas" showGoBack={false} >
                <div>
                    {can(RolePermissions.rules.create) && (
                        <AppButton
                            title="Crear plantilla"
                            state="primary"
                            onClick={() => navigate('/templates/create')}
                        />
                    )}
                </div>
            </HeaderPageSection>
            <PatternList />
        </Layout>
    )
}
